import { useEffect, useState } from 'react';

import { Breakpoint, PixelsPerBreakpoint } from '../constants/Breakpoint';

const getBreakpointBySize = (size: number) => {
  const breakpointEntries = Object.entries(PixelsPerBreakpoint) as [Breakpoint, number][];

  let breakpoint = Breakpoint.xs;

  // eslint-disable-next-line no-restricted-syntax
  for (const [breakpointName, breakpointSize] of breakpointEntries) {
    if (breakpointSize <= size) {
      breakpoint = breakpointName;
    } else {
      break;
    }
  }

  return breakpoint;
};

const isValidBreakPoint = (breakpoint: unknown): breakpoint is Breakpoint => {
  return (
    typeof breakpoint === 'string' &&
    Object.keys(PixelsPerBreakpoint).includes(breakpoint)
  );
};

export const useBreakpoint = () => {
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);

  const handleWindowResize = () => {
    setViewportWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);

    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  const isUpwards = (breakpointOrSizeInPx: Breakpoint | number) => {
    if (!isValidBreakPoint(breakpointOrSizeInPx)) {
      return viewportWidth >= breakpointOrSizeInPx;
    }

    return viewportWidth >= PixelsPerBreakpoint[breakpointOrSizeInPx];
  };

  const isDownwards = (breakpointOrSizeInPx: Breakpoint | number) => {
    if (!isValidBreakPoint(breakpointOrSizeInPx)) {
      return viewportWidth <= breakpointOrSizeInPx;
    }

    return viewportWidth <= PixelsPerBreakpoint[breakpointOrSizeInPx];
  };

  const isBetween = (
    lowestBreakpointOrSizeInPx: Breakpoint | number,
    higherBreakpointOrSizeInPx: Breakpoint | number,
  ) => isUpwards(lowestBreakpointOrSizeInPx) && isDownwards(higherBreakpointOrSizeInPx);

  return {
    current: getBreakpointBySize(viewportWidth),
    isUpwards,
    isDownwards,
    isBetween,
  };
};
